// Array.from where the browser has it, so iterables work too; IE 11 takes array-likes only, holes included
export default function arrayFrom(value, mapFn, thisArg) {
  if (Array.from) return Array.from(value, mapFn, thisArg);
  var length = Math.max(0, Math.floor(value.length) || 0);
  var result = [];
  for (var i = 0; i < length; i++) result.push(mapFn ? mapFn.call(thisArg, value[i], i) : value[i]);
  return result;
}